import { render } from "./AddTaskData.vue?vue&type=template&id=1b67bc5a"
import script from "./AddTaskData.vue?vue&type=script&lang=js"
export * from "./AddTaskData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__